import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import EvaluationCompetencyServices from "./EvaluationCompetency.services";
import { ResponsiveEmbed } from "react-bootstrap";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

//competencias del empleado
export const resetEmployeeCompetency = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEE_COMPETENCY,
      payload: true,
    });
    dispatch({
      type: actions.GET_EMPLOYEE_COMPETENCY,
      payload: {
        employeeCompetencies: [],
        employeeCompetenciesLength: 0,
      },
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.EMPLOYEE_COMPETENCY_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_COMPETENCY,
      payload: false,
    });
  }
};

export const getEmployeeCompetency = (filters) => async (dispatch) => {
  try {

    dispatch({
      type: actions.LOADING_EMPLOYEE_COMPETENCY,
      payload: true,
    });
    const resp = await EvaluationCompetencyServices.getEmployeeCompetency(filters);
    dispatch({
      type: actions.GET_EMPLOYEE_COMPETENCY,
      payload: {
        employeeCompetencies: resp.data || [],
        employeeCompetenciesLength: resp.data.count || 0,
      },
    });
    dispatch({
      type: actions.EMPLOYEE_COMPETENCY_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.EMPLOYEE_COMPETENCY_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_COMPETENCY,
      payload: false,
    });
  }
};

export const getEmployeeCompetencyById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEE_COMPETENCY_BY_ID,
      payload: true,
    });
    const resp = await EvaluationCompetencyServices.getEmployeeCompetencyById(id);
    dispatch({
      type: actions.GET_EMPLOYEE_COMPETENCY_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.EMPLOYEE_COMPETENCY_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.EMPLOYEE_COMPETENCY_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_COMPETENCY_BY_ID,
      payload: false,
    });
  }
};

export const saveEmployeeCompetency = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_EMPLOYEE_COMPETENCY,
      payload: true,
    });
    const resp = await EvaluationCompetencyServices.saveEmployeeCompetency(data);
    const { employeeCompetencies, employeeCompetenciesLength } = getState().evaluationCompetency;
    const _employeeCompetencies = employeeCompetencies
    _employeeCompetencies.data = [...employeeCompetencies.data, resp.data];
    dispatch({
      type: actions.GET_EMPLOYEE_COMPETENCY,
      payload: {
        employeeCompetencies: _employeeCompetencies,
        employeeCompetenciesLength: employeeCompetenciesLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL_EMPLOYEE_COMPETENCY,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL_EMPLOYEE_COMPETENCY,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_EMPLOYEE_COMPETENCY,
      payload: false,
    });
  }
};

export const editEmployeeCompetency = (data, id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_EMPLOYEE_COMPETENCY,
      payload: true,
    });
    await EvaluationCompetencyServices.editEmployeeCompetency(id, data);
   
    dispatch({
      type: actions.FORM_FAIL_EMPLOYEE_COMPETENCY,
      payload: "",
    });
   
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL_EMPLOYEE_COMPETENCY,
      payload: message,
    });
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_EMPLOYEE_COMPETENCY,
      payload: false,
    });
  }
};

export const editEmployeeComment = (data, id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_EMPLOYEE_COMPETENCY,
      payload: true,
    });
    await EvaluationCompetencyServices.editEmployeeCompetency(id, data);
    dispatch({
      type: actions.FORM_FAIL_EMPLOYEE_COMPETENCY,
      payload: "",
    });   
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL_EMPLOYEE_COMPETENCY,
      payload: message,
    });
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_EMPLOYEE_COMPETENCY,
      payload: false,
    });
  }
};

export const deleteEmployeeCompetency = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EMPLOYEE_COMPETENCY,
      payload: true,
    });
    await EvaluationCompetencyServices.deleteEmployeeCompetency(id);
    const { employeeCompetencies, employeeCompetenciesLength } = getState().evaluationCompetency;
    employeeCompetencies.data.splice(index, 1);
    dispatch({
      type: actions.GET_EMPLOYEE_COMPETENCY,
      payload: {
        employeeCompetencies: employeeCompetencies,
        employeeCompetenciesLength: employeeCompetenciesLength - 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL_EMPLOYEE_COMPETENCY,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data && ex.response.data[0]) {
              message = ex.response.data[0];
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EMPLOYEE_COMPETENCY,
      payload: false,
    });
  }
};

//competencias del jefe

export const resetBossCompetency = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_BOSS_COMPETENCY,
      payload: true,
    });
    dispatch({
      type: actions.GET_BOSS_COMPETENCY,
      payload: {
        bossCompetencies: [],
        bossCompetenciesLength: 0,
      },
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.BOSS_COMPETENCY_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_BOSS_COMPETENCY,
      payload: false,
    });
  }
};

export const getBossCompetency = (filters) => async (dispatch) => {
  try {

    dispatch({
      type: actions.LOADING_BOSS_COMPETENCY,
      payload: true,
    });
    const resp = await EvaluationCompetencyServices.getBossCompetency(filters);
    dispatch({
      type: actions.GET_BOSS_COMPETENCY,
      payload: {
        bossCompetencies: resp.data || [],
        bossCompetenciesLength: resp.data.count || 0,
      },
    });
    dispatch({
      type: actions.BOSS_COMPETENCY_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.BOSS_COMPETENCY_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_BOSS_COMPETENCY,
      payload: false,
    });
  }
};

export const getBossCompetencyById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_BOSS_COMPETENCY_BY_ID,
      payload: true,
    });
    const resp = await EvaluationCompetencyServices.getBossCompetencyById(id);
    dispatch({
      type: actions.GET_BOSS_COMPETENCY_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.BOSS_COMPETENCY_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.BOSS_COMPETENCY_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_BOSS_COMPETENCY_BY_ID,
      payload: false,
    });
  }
};

export const saveBossCompetency = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_BOSS_COMPETENCY,
      payload: true,
    });
    const resp = await EvaluationCompetencyServices.saveBossCompetency(data);
    const { bossCompetencies, bossCompetenciesLength } = getState().evaluationCompetency;
    const _bossCompetencies = bossCompetencies
    _bossCompetencies.data = [...bossCompetencies.data, resp.data];
    dispatch({
      type: actions.GET_BOSS_COMPETENCY,
      payload: {
        bossCompetencies: _bossCompetencies,
        bossCompetenciesLength: bossCompetenciesLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL_BOSS_COMPETENCY,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL_BOSS_COMPETENCY,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_BOSS_COMPETENCY,
      payload: false,
    });
  }
};

export const editBossCompetency = (data, id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_BOSS_COMPETENCY,
      payload: true,
    });
    await EvaluationCompetencyServices.editBossCompetency(id, data);
    dispatch({
      type: actions.FORM_FAIL_BOSS_COMPETENCY,
      payload: "",
    });
    
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL_BOSS_COMPETENCY,
      payload: message,
    });
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_BOSS_COMPETENCY,
      payload: false,
    });
  }
};

export const editBossComment = (data, id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_BOSS_COMPETENCY,
      payload: true,
    });
    await EvaluationCompetencyServices.editBossCompetency(id, data);   
    dispatch({
      type: actions.FORM_FAIL_BOSS_COMPETENCY,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL_BOSS_COMPETENCY,
      payload: message,
    });
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_BOSS_COMPETENCY,
      payload: false,
    });
  }
};

export const deleteBossCompetency = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_BOSS_COMPETENCY,
      payload: true,
    });
    await EvaluationCompetencyServices.deleteBossCompetency(id);
    const { bossCompetencies, bossCompetenciesLength } = getState().evaluationCompetency;
    bossCompetencies.data.splice(index, 1);
    dispatch({
      type: actions.GET_BOSS_COMPETENCY,
      payload: {
        bossCompetencies: bossCompetencies,
        bossCompetenciesLength: bossCompetenciesLength - 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL_BOSS_COMPETENCY,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data && ex.response.data[0]) {
              message = ex.response.data[0];
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.LOADING_BOSS_COMPETENCY,
      payload: false,
    });
  }
};
